import { useFormikContext } from 'formik';
import React, { useEffect, useRef } from 'react';

export function FormikChangeListener<T>(props: { children: (oldValues: T, newValues: T) => void }) {
  const formik = useFormikContext();
  const oldValues = useRef<T>(formik.values as T);

  //Every time the formik values change the callback function is used.
  const callback = () => {
    //initially oldValues.current is undefined
    props.children(oldValues.current, formik.values as T);
    //After the first call, the oldValues change
    oldValues.current = formik.values as T;
  };

  useEffect(callback, [formik.values]);

  return <></>;
}
